<!-- Loader -->
<ng-container *ngIf="loading">
  <div class="spinner">
    <div class="columns">
      <div class="tabs-container">
        <div class="column">
          <div
            class="tabs is-small has-background-white-bis has-text-weight-bold"
          >
            <div class="tabs-wrapper">
              <ul>
                <li class="is-active">
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="spinner--label"></div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="card is-shadowless p-8 p-4-mobile is-bordered">
          <div class="columns">
            <div
              class="column is-7-tablet is-8-desktop is-flex is-flex-direction-column is-justify-content-stretch"
            >
              <div class="spinner--label mb-2"></div>
              <div class="spinner--h5 mb-2"></div>
              <div
                class="card is-fullheight is-fullwidth is-flex is-align-items-center is-justify-content-center is-shadowless has-background-white-bis"
              >
                <div class="loader--chart">
                  <div class="dot1"></div>
                  <div class="dot2"></div>
                </div>
              </div>
            </div>
            <div class="column is-5-tablet is-4-desktop">
              <div
                class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
              >
                <div class="card-content">
                  <div class="content is-small">
                    <div class="spinner--h5 mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--h6 mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mt-4"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mt-4"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--h6 mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                    <div class="spinner--p mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Tabs -->
<div
  class="columns"
  *ngIf="!loading && layout === 'tabs' && aggregations.length > 1"
>
  <div class="tabs-container">
    <div class="column">
      <div class="tabs is-small has-background-white-bis has-text-weight-bold">
        <div class="tabs-wrapper">
          <ul>
            <li
              *ngFor="let aggregation of aggregations"
              [ngClass]="{
            'is-active': selectedAggregation?.id === aggregation.id
          }"
            >
              <a (click)="selectedAggregation = aggregation">
                {{ aggregation.label }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Aggregation -->
<div class="columns" *ngIf="selectedAggregation">
  <div class="column">
    <div class="card is-shadowless p-8 p-4-mobile is-bordered">
      <div class="columns">
        <div
          class="column"
          [ngClass]="{
            'is-7-tablet is-8-desktop': selectedAggregation.helpText
          }"
        >
          <app-aggregation-wrapper
            [aggregation]="selectedAggregation"
          ></app-aggregation-wrapper>
        </div>
        <div
          class="column is-5-tablet is-4-desktop"
          *ngIf="selectedAggregation.helpText"
        >
          <div
            class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
          >
            <div class="card-content">
              <div
                class="content is-small"
                [innerHTML]="selectedAggregation.helpText"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- On list view we display all aggregations one below the other -->
<ng-container *ngIf="layout === 'list'">
  <div class="columns" *ngFor="let aggregation of aggregations">
    <div class="column">
      <div class="card is-shadowless p-8 p-4-mobile is-bordered">
        <div class="columns">
          <div
            class="column"
            [ngClass]="{
              'is-7-tablet is-8-desktop': aggregation.helpText
            }"
          >
            <app-aggregation-wrapper
              [aggregation]="aggregation"
            ></app-aggregation-wrapper>
          </div>
          <div
            class="column is-5-tablet is-4-desktop"
            *ngIf="aggregation.helpText"
          >
            <div
              class="card is-fullwidth is-fullheight has-background-white-bis is-shadowless"
            >
              <div class="card-content">
                <div
                  class="content is-small"
                  [innerHTML]="aggregation.helpText"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
